import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { apiLinks } from 'src/app/core/api-links/api-links';
import { CommonService } from 'src/app/providers/common.service';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MerchantService } from 'src/app/providers/merchant.service';
import { Subject, of, forkJoin } from 'rxjs';
import {
  debounceTime,
  switchMap,
  tap,
  map,
  finalize,
  catchError,
  take,
  filter,
  distinctUntilChanged
} from 'rxjs/operators';
import { LoginAsModalComponent } from 'src/app/shared/components/login-as-modal/login-as-modal.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/providers/auth.service';
import { UserService } from 'src/app/providers/user.service';
import { Users } from 'src/app/core/model/user';
import { DownloaderLoaderComponent } from 'src/app/shared/components/downloader-loader/downloader-loader.component';
import * as fs from 'file-saver';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-invoice-detail',
  templateUrl: './invoice-detail.component.html',
  styleUrls: ['./invoice-detail.component.scss']
})
export class InvoiceDetailComponent implements OnInit {
  public customerInfo: any = localStorage.getItem('current_user') ? JSON.parse(localStorage.getItem('current_user')) : {};
  status = [
    { name: "PENDING", id: "PENDING" },
    { name: "APPROVED", id: "APPROVED" },
    { name: "FAILED", id: "DECLINED" },
  ];
  public invoice: any = {};
  statusTypes = [];
  monthList = moment.months().map((data, index) => {
    return { label: data, value: index + 1 };
  });
  startYear = 2022;
  yearList: Number[] = [];


  viewMode: number = 0;
  viewInvoice: any;
  DownloadModalReference: any;
  collectionSize: any;
  page = 1;
  limit = 10;
  size = 10;
  isLoading: boolean = true;
  public invoiceIdloading: boolean = false;
  public merchantLoading: boolean = false;
  public isFilter: boolean = false;
  public isFormValid: boolean = false;
  public billingNotebaled: boolean = false;
  public paginationLoader: boolean = false;
  searchTimeout: any;
  searchMerchantTimeout: any;
  notFoundText = 'Type at least 3 letters';
  merchantNotFoundText = 'Type at least 3 letters';
  merchants$: any;
  public filterFormGroup: FormGroup;
  public invoiceIdsList: any[] = [];
  public merchantsList: any[] = [];
  search$ = new Subject<string>();
  filterMerchantInfo: any = {};
  public billingSummary: any = {}
  public billingStatus: any = {};

  constructor(private common: CommonService, private messageService: MessageService, private httpClient: HttpClient,
    private activeRoute: ActivatedRoute, private merchantService: MerchantService, private router: Router,
    private ngbModal: NgbModal, private userService: UserService, private authService: AuthService,) {
    this.billingSummary = this.routeParams.billingSummary ? JSON.parse(this.routeParams.billingSummary) : {};
    this.billingStatus = this.routeParams.billingStatus ? JSON.parse(this.routeParams.billingStatus) : {};
  }
  public routeParams = this.activeRoute.snapshot.queryParams;
  public invoiceDownloadLoader = '';
  ngOnInit(): void {
    this.filterFormGroup = new FormGroup({
      month: new FormControl(Number(this.routeParams.month) || null),
      year: new FormControl(Number(this.routeParams.year) || null),
      merchantId: new FormControl(null),
      invoiceNumber: new FormControl(this.routeParams.invoiceNumber),
      invoiceStatus: new FormControl(null),
    });
    let selectedYear = Number(moment().format("YYYY"));
    for (let i = this.startYear; i <= selectedYear; i++) {
      this.yearList.push(i);
    }
    this.invoiceIdsList = this.routeParams.invoiceNumber ? [{ invoiceNumber: this.routeParams.invoiceNumber }] : [];
    this.filterFormGroup.valueChanges.subscribe(values => {
      this.isFormValid = Object.values(values).some(value => value !== null && value !== '');
      if (!this.isFormValid) {
        this.getInvoiceDetails()
      }
    });
    this.filterFormGroup.updateValueAndValidity()
    this.searchInit();
    const previousFilter = localStorage.getItem('m_b_invoice_filter')
      ? JSON.parse(localStorage.getItem('m_b_invoice_filter')) : null;
    if (previousFilter) {
      localStorage.removeItem('m_b_invoice_filter')
      if (previousFilter.merchantId) {
        setTimeout(() => {
          this.search$.next(previousFilter.dba)
        }, 50);
      }
      this.invoiceIdsList = previousFilter.invoiceNumber ? [{ invoiceNumber: previousFilter.invoiceNumber }] : [];
      this.merchantsList = previousFilter.merchantId ? [{ dba: previousFilter.dba, id: previousFilter.id }] : [];
      this.filterFormGroup.setValue({
        month: previousFilter.month,
        year: previousFilter.year,
        merchantId: previousFilter.merchantId,
        invoiceNumber: previousFilter.invoiceNumber,
        invoiceStatus: previousFilter.invoiceStatus,
      })
      this.getInvoiceDetails();
    } else {
      this.getInvoiceDetails();
    }

  }

  clear() {
    this.filterFormGroup.reset();
    this.isLoading = true;
    this.getInvoiceDetails();
  }

  searchInit = () => {

    this.merchants$ = this.search$.pipe(
      filter(term => term?.length >= 3),
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => {
        this.merchantLoading = true;
        this.merchantNotFoundText = 'No results found';
      }),
      switchMap(term =>
        this.merchantService
          .getAllMerchant({ isFilter: true, page: 1, size: 500, queryString: term })
          .pipe(
            map(res => (res.data.items || []).map(d => ({ id: d.id, dba: d.dba }))),
            tap(list => {
              this.merchantsList = list;
            }),
            catchError(() => {
              this.merchantLoading = false;
              this.merchantsList = [];
              return of([]);
            }),
            finalize(() => (this.merchantLoading = false))
          )
      )
    );
  }

  selected(index) {
    this.viewMode = index;
  }

  currentInvoiceDetail(invoice) {
    this.viewInvoice = invoice;
  }
  getInvoiceDetails = () => {
    const filter = {
      ...this.filterFormGroup.value,
      page: this.page, size: this.size
    };
    this.common.postCommonHttpClient(`${apiLinks.merchantBilling.getInvoiceDetails}`, filter).pipe(take(1)).subscribe((res: any) => {
      this.isLoading = this.paginationLoader = false;
      this.filterMerchantInfo = this.merchantsList.find((d: any) => { return d.id == this.filterFormGroup.get('merchantId').value });
      if (res.message_code === 'BILLING_NOT_ENABLED') {
        this.billingNotebaled = true;
        return;
      }
      this.billingNotebaled = false;
      if (!res.data?.invoices?.length) {
        this.showToaster('error', '', 'No invoices found');
      }

      this.invoice = res.data;
      this.collectionSize = this.invoice?.summary?.totalMerchants || 0;
      this.currentInvoiceDetail(this.invoice?.invoices?.length ? this.invoice.invoices?.length ? this.invoice.invoices[0] : {} : {})

    }, error => {
      this.isLoading = this.paginationLoader = false;
      // this.showToaster('error', '', error.message);
    })
  }

  showToaster(type, define, message, id?: string) {
    this.messageService.add({
      severity: type,
      summary: define,
      detail: message,
      key: 'copy-toast'
    });
  }

  getPage(page: number) {
    this.page = page;
    console.log('page', page);
    this.paginationLoader = true;
    this.getInvoiceDetails();
  }
  onSearchInvoiceId(term: string) {
    clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(() => {
      if (term?.length >= 3) {
        this.invoiceIdloading = true;
        this.notFoundText = 'No results found';
        this.getInvoicesIdList(term);
      } else {
        this.notFoundText = 'Type at least 3 letters';
        this.invoiceIdsList = [];
        this.invoiceIdloading = false;
      }
    }, 300);
  }

  getInvoicesIdList = (term: string) => {
    this.common.getCommonHttpClientParams(`${apiLinks.merchantBilling.getInvoiceIds}?term=${term}`).pipe(take(1)).subscribe((res: any) => {
      this.invoiceIdsList = res.data.items || [];
      this.invoiceIdloading = false;

    }, error => {
      this.invoiceIdloading = false;
      this.invoiceIdsList = [];
    })
  }
  searchFn = () => {
    this.isFilter = this.isLoading = true;

    this.getInvoiceDetails();
  }

  preserveFilter = () => {
    localStorage.setItem('m_b_invoice_filter', JSON.stringify({ ...this.filterFormGroup.value, ...this.filterMerchantInfo }))
  }
  navigateToBilling(isEdit?: boolean) {
    this.preserveFilter();
    this.router.navigate(['/billing-invoice/merchant-contract'], {
      queryParams: { mid: this.filterMerchantInfo?.id, merDba: this.filterMerchantInfo?.dba, ...(isEdit ? { ebill: isEdit } : {}), backtopage: 'm-b-invoice-details' }
    });
  }

  navigateFn = (path: string, params?: any) => {

    params = { ...params, ...this.billingStatus, ...this.billingSummary }
    this.router.navigate([`/billing-invoice/${path}`], { queryParams: params || {} });
  }
  loginAs() {
    if (!this.billingSummary.accountInfo?.userId) {
      return;
    }
    let modalRef = this.ngbModal.open(LoginAsModalComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.isLoading = true
    modalRef.componentInstance.header = `LOGIN-AS CONFIRMATION`;
    let payLoad = {
      ownedByCustomer: this.customerInfo.customerId
    };
    let getUserApi = this.userService.getUser(this.userService.getUserById, { id: this.billingSummary.accountInfo?.userId });
    let getProxyEmailStatusApi = this.common.getCommonHttpClientQueryParams(apiLinks.isEnableProxyEmailAlert, payLoad);
    forkJoin([getUserApi, getProxyEmailStatusApi]).pipe(take(1)).subscribe(([userApiRes, proxyEmailRes]) => {
      const userResponse = userApiRes as Users
      modalRef.componentInstance.body = `Do you want to login as your Collection Account ?`;
      modalRef.componentInstance.confirmButton = `Confirm`
      modalRef.componentInstance.email = userResponse.email;
      // modalRef.componentInstance.password = userResponse.secondaryPassword;
      modalRef.componentInstance.systemUser = this.authService.getUser.firstName + " " + this.authService.getUser.lastName;
      modalRef.componentInstance.systemEmail = this.authService.getUser.email;
      modalRef.componentInstance.isLoading = false;
      modalRef.componentInstance.loginUser = 'Merchant';
      modalRef.componentInstance.isEnableProxyEmail = proxyEmailRes.isEnableProxyMail;
    }, (err) => {
      modalRef.componentInstance.isLoading = false
      modalRef.componentInstance.body = `Error occurred, ${err.message}`;
      modalRef.componentInstance.isError = true

    });

  }

  showDownloadDialog(bodyContent = "Downloading") {
    window.scroll(0, 0);
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'lg',
    };
    this.DownloadModalReference = this.ngbModal.open(DownloaderLoaderComponent, ngbModalOptions);
    this.DownloadModalReference.componentInstance.isLoading = true;
    this.DownloadModalReference.componentInstance.body = bodyContent;
  }

  download() {
    this.showDownloadDialog();
    this.common
      .postCommonFileDownload(
        apiLinks.merchantBilling.invoiceDownload,
        this.filterFormGroup.value
      )
      .subscribe({
        next: (blob: Blob) => {
          const date = new Date().toISOString().slice(0, 10);
          const fileName = `Invoices-${date}.xlsx`;
          const url = window.URL.createObjectURL(blob);
          fs.saveAs(url, fileName);
          window.URL.revokeObjectURL(url);
          this.DownloadModalReference?.close();
        },
        error: (err: any) => {
          if (err.error instanceof Blob && err.error.type.includes('application/json')) {
            err.error.text().then((text: string) => {
              let msg = 'Unknown server error';
              try {
                msg = JSON.parse(text)?.message || msg;
              } catch {
                msg = text;
              }
              this.showToaster('error', '', msg);
              this.DownloadModalReference?.close();
            });
          } else {
            this.showToaster('error', '', err.message || 'Download failed');
            this.DownloadModalReference?.close();
          }
        }
      });
  }

  downloadInvoice = async (data: any, type: string) => {
    this.invoiceDownloadLoader = type;
    this.common.getCommonHttpClientQueryParams(apiLinks.merchantBilling.s3Link, { key: type == 'excel' ? data.invoiceDetailsExcel : data.invoicePdf }).subscribe((res: any) => {
      const date = new Date().toISOString().slice(0, 10);
      const ext = type === 'pdf' ? '.pdf' : '.xlsx';
      const fileName = `Invoices-${date}-${data.merchantDba}${ext}`;

      this.httpClient
        .get(res.signedUrl, { responseType: 'blob' })
        .subscribe({
          next: (blob) => {
            this.invoiceDownloadLoader = '';
            fs.saveAs(blob, fileName);
          },
          error: (err) => {
            this.showToaster('error', '', err?.message || 'Download failed');
            this.invoiceDownloadLoader = '';
          }
        });

    }, error => {
      this.showToaster('error', '', error?.message || 'Download failed');
      this.invoiceDownloadLoader = '';

    });
  }
}
